import { enablePatches } from 'unitx/immer';
import React from 'react';
import * as R from 'unitx/ramda';
import createPatchHistory from "../utils/createPatchHistory";
import { produceWithPatchesAsync } from "../utils/immerAsync";
import useTaskQueue from "./useTaskQueue";
/* eslint-disable functional/immutable-data, functional/no-expression-statement */

enablePatches();
/* eslint-enable functional/immutable-data, functional/no-expression-statement */

const CONCURRENCY = 1;
export default ((initialValue, config = {}) => {
  // type Updater = (value: T) => UR
  const {
    history = false
  } = config;
  const [state, setState] = React.useState({
    value: initialValue,
    patches: [],
    inversePatches: [],
    updaterReturn: null,
    history: history ? createPatchHistory() : null
  });
  const stateRef = React.useRef({
    state,
    setState
  });
  stateRef.current = {
    state,
    setState
  }; /// CREATE_QUEUE

  const queue = useTaskQueue({
    concurrency: CONCURRENCY
  }); // const queue = React.useMemo(() => createQueue(
  //   async (task: Updater, callback: () => void) => {
  //     let updaterReturn: UR = null
  //     const [nextState, patches, inversePatches] = await produceWithPatchesAsync(
  //       stateRef.current.state.value, async (draft: T) => {
  //         updaterReturn = await task(draft)
  //       },
  //     )
  //     R.when(
  //       R.isTrue,
  //       () => {
  //       stateRef.current.state.history?.add(
  //         // @ts-ignore
  //         updaterReturn?.historyName,
  //         { patches, inversePatches }
  //       )
  //       },
  //       // @ts-ignore
  //     )(history && !!updaterReturn?.historyName)
  //     stateRef.current.setState({
  //       value: nextState,
  //       patches,
  //       inversePatches,
  //       updaterReturn: updaterReturn as UR,
  //       history: state.history,
  //     })
  //     callback()
  //   }, CONCURRENCY,
  // ),
  // [])
  /// ADD_QUEUE

  const callback = React.useCallback(async updater => {
    // queue.push(updater)
    queue.push(async () => {
      var _updaterReturn2;

      let updaterReturn = null;
      const [nextState, patches, inversePatches] = await produceWithPatchesAsync(stateRef.current.state.value, async draft => {
        // @ts-ignore
        updaterReturn = await updater(draft);
      });
      R.when(R.isTrue, () => {
        var _stateRef$current$sta, _updaterReturn;

        (_stateRef$current$sta = stateRef.current.state.history) === null || _stateRef$current$sta === void 0 ? void 0 : _stateRef$current$sta.add( // @ts-ignore
        (_updaterReturn = updaterReturn) === null || _updaterReturn === void 0 ? void 0 : _updaterReturn.historyName, {
          patches,
          inversePatches
        });
      } // @ts-ignore
      )(history && !!((_updaterReturn2 = updaterReturn) === null || _updaterReturn2 === void 0 ? void 0 : _updaterReturn2.historyName));
      stateRef.current.setState({
        value: nextState,
        patches,
        inversePatches,
        updaterReturn: updaterReturn,
        history: state.history
      });
    });
  }, []);
  return [state.value, callback, {
    patches: state.patches,
    inversePatches: state.inversePatches,
    updaterReturn: state.updaterReturn,
    history: state.history
  }];
});